import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const useGetCompanyBySlug = () => {
  const { data, isLoading, error, send } = useRequest({
    method: ApiMethodsEnum.Get,
    sendOnStart: false,
  });

  const getCompanyBySlug = (slug: string) => {
    send({}, `/api/v1/companies/${slug}`).then();
  };

  return {
    getCompanyBySlug,
    data,
    isLoading,
    error,
  };
};
